import {DialogTypes} from 'common/names';
import {ICloseSubDialogAction} from 'features/layout/redux/actions';
import {call, put, select} from 'redux-saga/effects';
import {FILE_SEPARATOR} from 'redux/server/hooks/useBrowseList';
import i18n from 'i18n';
import {asyncSagaConstructor} from 'redux/common';
import api from 'api';
import {backupTypes} from 'redux/backuprestore';
import {IDiplomatFile} from 'types/DiplomatFile';
import {FileManagerDialogData} from 'features/layout/DialogRoutes/dialogs/FileManagerDialog/FileManagerDialogWrapper';
import {openDialogWithResult} from 'redux/common/saga/openDialogWithResult';
import {pushErrorToast} from 'features/notifications/redux/actions';
import {isString} from 'lodash';
import {licenseSelectors} from 'redux/license';
import {DiplomatFeature} from 'types/DiplomatFeature';
import {
   FileManagerMergeDialogData,
   FileManagerMergeDialogResult,
} from 'features/layout/DialogRoutes/dialogs/FileManagerDialog/FileManagerMergeDialog';

const DBU_EXT = '*.dbu';
const DMRG_EXT = '*.dmrg';
export function* getBackupFilePath(dialogTitle: string, isMerge: boolean = false) {
   const isFeatureSupported = (yield select(licenseSelectors.isFeatureSupported)) as ReturnType<
      typeof licenseSelectors.isFeatureSupported
   >;
   const defaultBackupDir: IDiplomatFile = yield call(
      asyncSagaConstructor(api.backupdir, backupTypes.GET_DEFAULT_DIR)
   );

   if (!defaultBackupDir.exists) {
      yield put(
         pushErrorToast(
            i18n.t(
               'Default backup directory does not exist and could not be created.  ' +
                  'Update backup directory under Settings > System > Backup.'
            )
         )
      );
   }

   const dbFilePathAction: ICloseSubDialogAction<FileManagerMergeDialogResult> = yield call(
      openDialogWithResult,
      {
         id: DialogTypes.FileManagerMerge.id,
         data: {
            title: dialogTitle,
            suspendCheckbox: isMerge,
            filesOfType: isFeatureSupported(DiplomatFeature.SELECTIVE_MERGE)
               ? isMerge
                  ? [DMRG_EXT, DBU_EXT]
                  : [DBU_EXT, DMRG_EXT]
               : [DBU_EXT],
            initialPath: defaultBackupDir.path + FILE_SEPARATOR,
            directoriesOnly: false,
         } as FileManagerMergeDialogData,
      }
   );

   return dbFilePathAction.payload?.data;
}
